module.exports = __webpack_public_path__ + "img/file.ad24d03e.svg";